<template>
  <div>
    <b-card>
      <b-card-text>Dibs</b-card-text>
      <b-button
        @click="dibsInvoke()"
      >
        Invoke
      </b-button>
      <div id="dibs-complete-checkout"></div>
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard, BCardText } from 'bootstrap-vue'

import axiosIns from '../libs/axios'

export default {
  components: {
    BCard,
    BCardText,
    BButton,
  },
  beforeCreate() {
    if (document.getElementById('dibs-script')) return // was already loaded
    const scriptTag = document.createElement('script')
    scriptTag.src = 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1'
    scriptTag.id = 'dibs-script'
    document.getElementsByTagName('head')[0].appendChild(scriptTag)
  },
  methods: {
    dibsInvoke() {
      let paymentID
      let obj
      axiosIns.get('api/dibs/create-payment?action=createPay').then(data => {
        paymentID = JSON.stringify(data)
        obj = JSON.parse(paymentID)
        console.log(obj)
        paymentID = obj.data.paymentId
        console.log(paymentID)
        const checkoutOptions = {
          paymentId: paymentID,
          checkoutKey: '25616be8f790488e8f2bed1f5ae80257',
          language: 'en-GB',
          containerId: 'dibs-complete-checkout',
        }
        console.log(checkoutOptions)
        /* eslint-disable */
        const checkout = new Dibs.Checkout(checkoutOptions)
        /* eslint-enable */
        console.log(checkout)

        checkout.on('payment-completed', response => {
          console.log(response)
          axiosIns.get('api/dibs/save-payment', {
            paymentID,
          }).then(res => {
            console.log(res)
          }).catch(e => {
            console.error(e)
          })
        })
      }).catch(e => {
        console.error(e)
      })
    },
  },
  // head() {
  //   return {
  //     script: [
  //       // { src: 'https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js' },
  //       // { src: 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1' },
  //     ],
  //   }
  // },
  mounted() {
  },
}
</script>

<style>

</style>
